import { createFileRoute } from '@tanstack/react-router'
import { StatusReportPrintPage } from '../../../../../../features/projects/status-reports/report-print-page'

/** A weekly status report printed, EN/AR in the reader's language (P7 decision 12). */
export const Route = createFileRoute('/_app/projects/$projectId/reports/$reportId/print')({
  staticData: { crumb: 'projectReportPrint' },
  component: StatusReportPrintPage,
})
